import "@/App.css";
import "@/Daily.css";
import "@/DiscoveryPath.css";
import "@/ContextualReading.css";
import "@/SelfDiscoveryFirst.css";
import "@/MobileCompact.css";
import "@/KnowYourselfJourney.css";
import "@/BlueprintExplanations.css";
import "@/Relationships.css";
import "@/ExperienceRefined.css";
import "@/TarotRefined.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider } from "@/components/AuthContext";
import { AuthCallback } from "@/components/AuthCallback";
import { SiteShell } from "@/components/SiteShell";
import TodayPage from "@/pages/TodayPage";
import TarotPage from "@/pages/TarotPage";
import WisdomPage from "@/pages/WisdomPage";
import MeaningsPage from "@/pages/MeaningsPage";
import BlueprintPage from "@/pages/BlueprintPage";
import EnergyNavigatorPage from "@/pages/EnergyNavigatorPage";
import TeachersPage from "@/pages/TeachersPage";
import SacralPage from "@/pages/SacralPage";
import MembershipPage from "@/pages/MembershipPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import MemberAccessPage from "@/pages/MemberAccessPage";
import TraditionsPage from "@/pages/TraditionsPage";
import KnowledgeAtlasPage from "@/pages/KnowledgeAtlasPage";
import MethodsPage from "@/pages/MethodsPage";
import IntuitiveArtsPage from "@/pages/IntuitiveArtsPage";
import ConnectionsPage from "@/pages/ConnectionsPage";
import { AppLinkListener } from "@/components/AppLinkListener";
import PrivacyPage from "@/pages/PrivacyPage";
import ExplorePage from "@/pages/ExplorePage";
import ReflectPage from "@/pages/ReflectPage";
import SignInPage from "@/pages/SignInPage";
import SelfDiscoveryPage from "@/pages/SelfDiscoveryPage";
import HomePage from "@/pages/HomePage";
import KnowYourselfPage from "@/pages/KnowYourselfPage";
import UnderstandOthersPage from "@/pages/UnderstandOthersPage";
import DiscoverPurposePage from "@/pages/DiscoverPurposePage";
import BlueprintDeepDivePage from "@/pages/BlueprintDeepDivePage";
import MemberJourneyPage from "@/pages/MemberJourneyPage";
import "@/MemberJourney.css";
import "@/ReferenceLibrary.css";
import "@/BeginnerGateway.css";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<SiteShell />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/know-yourself" element={<KnowYourselfPage />} />
        <Route path="/understand-others" element={<UnderstandOthersPage />} />
        <Route path="/discover-purpose" element={<DiscoverPurposePage />} />
        <Route path="/guided-path" element={<SelfDiscoveryPage />} />
        <Route path="/today" element={<TodayPage />} />
        <Route path="/journey" element={<Navigate to="/guided-path" replace />} />
        <Route path="/knowledge" element={<KnowledgeAtlasPage />} />
        <Route path="/methods" element={<MethodsPage />} />
        <Route path="/knowledge/intuitive" element={<IntuitiveArtsPage />} />
        <Route path="/blueprint" element={<Navigate to="/app/blueprint" replace />} />
        <Route path="/app/discovery" element={<Navigate to="/guided-path" replace />} />
        <Route path="/app/blueprint" element={<BlueprintPage />} />
        <Route path="/app/blueprint/explain/:topic" element={<BlueprintDeepDivePage />} />
        <Route path="/app/energy" element={<EnergyNavigatorPage />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/app/teachers" element={<TeachersPage />} />
        <Route path="/reflect" element={<ReflectPage />} />
        <Route path="/companion" element={<Navigate to="/reflect" replace />} />
        <Route path="/tarot" element={<TarotPage />} />
        <Route path="/app/sacral" element={<SacralPage />} />
        <Route path="/journal" element={<Navigate to="/reflect?mode=journal" replace />} />
        <Route path="/wisdom" element={<WisdomPage />} />
        <Route path="/app/traditions" element={<TraditionsPage />} />
        <Route path="/meanings" element={<Navigate to="/app/meanings" replace />} />
        <Route path="/app/meanings" element={<MeaningsPage />} />
        <Route path="/app/connections" element={<ConnectionsPage />} />
        <Route path="/membership" element={<MembershipPage />} />
        <Route path="/member" element={<MemberAccessPage />} />
        <Route path="/member/journey" element={<MemberJourneyPage />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/sign-in" element={<SignInPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return <BrowserRouter><AuthProvider><AppLinkListener/><AppRoutes /></AuthProvider></BrowserRouter>;
}